"use strict";

function e(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var r = e(require("@babel/runtime/helpers/objectSpread")),
    t = e(require("@babel/runtime/helpers/slicedToArray")),
    n = require("react"),
    a = e(require("@babel/runtime/regenerator")),
    u = e(require("@babel/runtime/helpers/asyncToGenerator")),
    i = e(require("@sinoui/http"));

function c(e, t) {
  switch (t.type) {
    case "FETCH_INIT":
      return r({}, e, {
        isLoading: !0,
        isError: !1
      });

    case "FETCH_SUCCESS":
      return r({}, e, {
        isError: !1,
        isLoading: !1,
        data: t.payload
      });

    case "FETCH_FAILURE":
      return r({}, e, {
        isLoading: !1,
        isError: !0
      });

    case "UPDATE_DATA":
      return r({}, e, {
        data: t.payload
      });

    default:
      return e;
  }
}

exports.default = function (e, o) {
  var s = {
    data: o,
    isLoading: !0,
    isError: !1
  },
      l = n.useReducer(c, s),
      p = t(l, 2),
      d = p[0],
      f = p[1],
      E = n.useRef(e),
      b = n.useRef(),
      y = n.useCallback(function () {
    b.current && (b.current(), b.current = void 0);
  }, []),
      T = n.useCallback(function (e) {
    var r = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];

    if (r || E.current !== e) {
      E.current = e, y();

      var n = function (e, r) {
        var t,
            n = !1,
            c = (t = u(a.mark(function t() {
          var u;
          return a.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return e({
                    type: "FETCH_INIT"
                  }), t.prev = 1, t.next = 4, i.get(r);

                case 4:
                  u = t.sent, n || e({
                    type: "FETCH_SUCCESS",
                    payload: u
                  }), t.next = 11;
                  break;

                case 8:
                  t.prev = 8, t.t0 = t.catch(1), n || e({
                    type: "FETCH_FAILURE"
                  });

                case 11:
                case "end":
                  return t.stop();
              }
            }
          }, t, null, [[1, 8]]);
        })), function () {
          return t.apply(this, arguments);
        });
        return [c(), function () {
          n = !0;
        }];
      }(f, e),
          c = t(n, 2),
          o = c[1];

      b.current = o;
    }
  }, [y]);
  return n.useEffect(function () {
    return T(E.current), y;
  }, [T, y]), r({}, d, {
    doFetch: T,
    updateData: function updateData(e) {
      f({
        type: "UPDATE_DATA",
        payload: e
      });
    }
  });
};